import { get } from 'lodash';

const parseContent = (content = '', dictionary = {}) => {
  return content.replace(/{{.*?}}/gi, message => {
    const path = message.slice(2, message.length - 2);
    return get(dictionary, path, '');
  });
};

export default parseContent;
